<template>
  <div class="contact-failure">
    <div
      class="contact-failure__error"
      :class="bgColorClass()"
    >
      <FontAwesomeIcon icon="circle-exclamation" />
      Oops, looks like verification is temporarily unavailable.
    </div>
    <div class="contact-failure__text">
      Don’t worry, please click 'Continue' below to move on to the next step.
    </div>
  </div>
</template>

<script>
import theme from '@/mixins/theme'

export default {
  name: 'ContactFailure',
  mixins: [theme]

}
</script>

<style scoped lang="scss">
.contact-failure {
  @apply text-center;

  &__error {
    @apply py-4 px-3 sm:py-2 font-semibold max-w-500 m-auto;
  }

  &__text {
    @apply text-sm mt-20 mb-120 sm:mb-80;
  }
}
</style>
